import React, { Suspense } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { MoreMenuProps } from './MoreMenu';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';

export const LazyMoreMenu: React.FunctionComponent<MoreMenuProps> = ({
  menuItems,
}) => {
  const MoreMenu = useLazyComponent(
    () => import(/* webpackChunkName: "more-menu" */ './MoreMenu'),
    { namedImport: 'MoreMenu' },
  );

  return (
    <ErrorBoundary
      tags={{
        ownershipArea: 'trello-teamplates',
        feature: 'Navigation More Menu',
      }}
    >
      <Suspense fallback={null}>
        <ChunkLoadErrorBoundary fallback={null}>
          <MoreMenu menuItems={menuItems} />
        </ChunkLoadErrorBoundary>
      </Suspense>
    </ErrorBoundary>
  );
};
